import styleInject from '../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".Form-module_field-container__nG2qp {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-100);\n}\n\n.Form-module_label-container__ezZmH {\n  display: flex;\n  gap: var(--size-200);\n}\n\n.Form-module_message-icon__6-0dn {\n  margin-top: var(--size-50);\n}";
var styles = {"field-container":"Form-module_field-container__nG2qp","label-container":"Form-module_label-container__ezZmH","message-icon":"Form-module_message-icon__6-0dn"};
styleInject(css_248z);

export { styles as default };
